import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

interface StaffOnlyDeleteCompleteDialogProps {
  onClose: () => void;
  succeededCount?: number;
  failedCount?: number;
  errorMessages?: string[];
}

export const StaffOnlyDeleteCompleteDialog = forwardRef<
  HTMLDialogElement,
  StaffOnlyDeleteCompleteDialogProps
>(
  (
    { onClose, succeededCount = 0, failedCount = 0, errorMessages = [] },
    ref,
  ) => {
    const { t } = useTranslation();

    return (
      <dialog className="dialog dialog--complete" ref={ref}>
        <div className="dialog__scroll">
          <div className="dialog__line">
            <div className="dialog__area">
              {/* 完了メッセージ */}
              <div className="dialog__text">
                <p className="dialog__text-line">
                  {t('staffOnly.messages.bulkCancelPartialSuccess', {
                    succeeded: succeededCount,
                    failed: failedCount,
                  })}
                </p>
                {errorMessages.length > 0 && (
                  <div className="dialog__text-line dialog__text-line-left l-mt20">
                    {errorMessages.map((msg, index) => (
                      <div key={index}>{msg}</div>
                    ))}
                  </div>
                )}
              </div>

              {/* 検索画面に戻るボタン */}
              <div className="dialog__actions">
                <button
                  type="button"
                  onClick={onClose}
                  className="dialog__btn dialog__btn--ok"
                >
                  {t('staffOnly.deleteCompleteDialog.backButton')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    );
  },
);

StaffOnlyDeleteCompleteDialog.displayName = 'StaffOnlyDeleteCompleteDialog';
